export default function ErrorDivContainer() {
	return (
		<div className="d-flex justify-content-center align-items-center vh-100">
			<div className="alert alert-danger text-center" role="alert">
				<div className="d-flex flex-column align-items-center">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="64"
						height="64"
						fill="currentColor"
						className="bi bi-exclamation-triangle mb-3"
						viewBox="0 0 16 16"
					>
						<path d="M7.938 2.016a.13.13 0 0 1 .125 0l6.857 3.864c.11.062.11.208 0 .27l-6.857 3.864a.13.13 0 0 1-.125 0L1.081 6.15c-.11-.062-.11-.208 0-.27l6.857-3.864zM4.502 3.605a.13.13 0 0 0-.125 0L1.8 5.093l2.577 1.454a.13.13 0 0 0 .125 0L7.687 5.17 4.502 3.605zm6.796 1.488a.13.13 0 0 1 .125 0l2.577 1.454-2.577 1.454a.13.13 0 0 1-.125 0L7.437 6.55 11.298 5.093z" />
						<path d="M7.938 4.58a.565.565 0 0 1 .495 0l6.857 3.864c.11.062.11.208 0 .27l-6.857 3.864a.565.565 0 0 1-.495 0L1.081 8.715c-.11-.062-.11-.208 0-.27l6.857-3.864zm0 1.414a.247.247 0 0 0-.247.247v2.486a.247.247 0 0 0 .247.247h.01a.247.247 0 0 0 .247-.247V6.241a.247.247 0 0 0-.247-.247h-.01zM7.993 11a.646.646 0 1 0 0-1.293.646.646 0 0 0 0 1.293z" />
					</svg>
					<h4 className="alert-heading">Error al cargar la información</h4>
					<p>Hubo un error al intentar cargar este modulo, por favor intenta mas tarde o contacta con el administrador</p>
					<hr />
				</div>
			</div>
		</div>
	);
}
